import { FC } from 'react';

import View from './view';

const UserAccountRequestPage: FC = () => {
  return <View />;
};
export default UserAccountRequestPage;
